export default "__VITE_ASSET__f4bf1751__"